define(["require", "exports", "./FiltersArticleStatus", "./FiltersUppercaseFirstChar"], function (require, exports, FiltersArticleStatus_1, FiltersUppercaseFirstChar_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.filters = void 0;
    exports.filters = {
        uppercaseFirstChar: FiltersUppercaseFirstChar_1.uppercaseFirstChar,
        articleStatusFilter: FiltersArticleStatus_1.articleStatusFilter
    };
});
//# sourceMappingURL=index.js.map